"use client";
import { useSyncExternalStore } from "react";

const subscribe = (onStoreChange: () => void) => {
  window.addEventListener("resize", onStoreChange);
  return () => window.removeEventListener("resize", onStoreChange);
};

// Tailwind's lg breakpoint. Read during render rather than copied into state,
// so the first paint already matches the layout that will be used.
const getSnapshot = () => window.innerWidth >= 1024;
const getServerSnapshot = () => false;

export const useIsDesktop = () =>
  useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
